export default "__VITE_ASSET__CGc3IZBQ__"